<template>
  <router-view name="erp" v-bind:key="$route.path"></router-view>
</template>
<script>
export default {
  name: "Erp",
};
</script>
